"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoQuote = exports.PaymentMethods = exports.MethodsTitle = exports.Name = exports.ProviderDetails = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  background: #f6fbfb;
  border-radius: 12px;
  box-sizing: border-box;
  cursor: pointer;
  flex-wrap: wrap;
  color: #131720;
  text-decoration: none;
`;
exports.ProviderDetails = styled_components_1.default.div `
  padding: 16px 0 16px 16px;
  display: flex;
  flex-direction: column;
  flex-basis: 60%;
  box-sizing: border-box;
`;
exports.Name = styled_components_1.default.div `
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0em;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;
exports.MethodsTitle = styled_components_1.default.div `
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #657089;
  text-align: left;
`;
exports.PaymentMethods = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  margin-top: 4px;
  row-gap: 4px;
`;
exports.NoQuote = styled_components_1.default.div `
  text-align: right;
  padding: 16px;
  display: flex;
  flex-direction: column;
  /* flex-basis: 60%; */
  box-sizing: border-box;

  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #3896ff;
`;
//# sourceMappingURL=styled.js.map